import { _get } from "./Axios";

export default class BillingApi {
    static get(koas_code) {
        return _get('/booking/Billing/get_by_koas/' + koas_code)
    }

    static getByDpjp(dpjp_code) {
        return _get('/booking/Billing/get_by_dpjp/' + dpjp_code)
    }
}